import { render, staticRenderFns } from "./GoodsShopLayout.vue?vue&type=template&id=2a2d62c3&scoped=true&"
import script from "./GoodsShopLayout.vue?vue&type=script&lang=js&"
export * from "./GoodsShopLayout.vue?vue&type=script&lang=js&"
import style0 from "./GoodsShopLayout.vue?vue&type=style&index=0&id=2a2d62c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d62c3",
  null
  
)

export default component.exports